import { render, staticRenderFns } from "./parrainage.vue?vue&type=template&id=298f5e17&scoped=true&"
import script from "./parrainage.vue?vue&type=script&lang=js&"
export * from "./parrainage.vue?vue&type=script&lang=js&"
import style0 from "./parrainage.vue?vue&type=style&index=0&id=298f5e17&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298f5e17",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/app/components/Header.vue').default,Button: require('/app/components/Button.vue').default,Faq: require('/app/components/Faq.vue').default,NetworkForm: require('/app/components/NetworkForm.vue').default,FooterV2: require('/app/components/FooterV2.vue').default,ModalVideo: require('/app/components/ModalVideo.vue').default})
